import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Autocomplete, Tab, TabList } from "@similarweb/ui-components";

import type { IAutocompleteStyledProps } from "pro-features/components/AutocompleteWebsites/types";

const { carbon, red } = colorsPalettes;

export const AutocompleteStyled = styled(Autocomplete)<IAutocompleteStyledProps & { hasBorder: boolean }>`
    ${({ hasBorder }) => hasBorder && `border: 1px solid ${carbon["50"]};`}
    width: 100%;
    &:hover {
        box-shadow: 0px 3px 5px ${carbon[25]};
    }
`;

export const Icon = styled(SWReactIcons)<{ color?: string }>`
    height: 16px;
    width: 16px;
    display: flex;
    ${({ color }) =>
        `
            svg path {
            fill: ${color};
        }
    `}
`;

const SelectedSiteContainer = styled.div`
    background-color: white;
    display: flex;
    align-items: center;
    border: 1px solid ${carbon[25]};
    min-height: 48px;
    border-radius: 8px;
    padding: 0 8px 0 16px;
`;

export const FakeInputContainerStyled = styled.div<{ isValid: boolean; marginTop?: number }>`
    .ListItemWebsite {
        height: 34px;
        background-color: transparent;
    }
    ${({ marginTop = 0 }) => `margin-top: ${marginTop}px;`}
    border: 1px solid ${carbon["50"]};
    border-radius: 3px;
    padding: 2px 0px;
    width: 100%;
    ${({ isValid }) =>
        !isValid &&
        `
            border-color: ${red["400"]};
        `}
`;

export const DotsLoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    padding-left: 50px;
    width: 100%;
`;

export const CustomTab = styled(Tab)<{ width?: string }>`
    ${({ width }) => `width: ${width};`}
    justify-content: start;
    gap: 8px;
`;

export const CustomTabList = styled(TabList)`
    display: flex;
`;
